var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v(" Return to "),_c('BaseLinkOpenNew',{attrs:{"url":"https://dmv.ri.gov/online-services","name":"RI DMV Online Services"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }